import React, { useState, useEffect, useRef } from 'react';
import { checkMenu } from '../Utils/Common';
import DefaultLayout from '../component/DefaultLayout';
import Footer from '../component/Footer';
import Api from '../config/Api';
import { Link as LinkRouter } from 'react-router-dom';
import { AiOutlinePlus, AiFillEdit, AiFillDelete } from 'react-icons/ai'
// import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Card from 'react-bootstrap/Card';
import { AiOutlineRollback } from "react-icons/ai";
import { useHistory, useParams } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';
import { FiSearch } from "react-icons/fi";
import moment from 'moment'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import InputMask from 'react-input-mask';
import { NumericFormat } from 'react-number-format';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
  ClassicEditor,
  Bold,
  Essentials,
  Heading,
  Indent,
  IndentBlock,
  Italic,
  Link,
  List,
  MediaEmbed,
  Paragraph,
  Table,
  Undo
} from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import dayjs from "dayjs";
import { RiSettings2Fill } from 'react-icons/ri';
import 'bootstrap/dist/css/bootstrap.min.css';

function Editnews() {
	const {id} = useParams();
	const history = useHistory();
	const [pages, setPages] = useState([]);
	const [sections, setSections] = useState([]);
	const [details, setDetails] = useState({});
	const [error, setError] = useState(null);
	const [errorForm, setErrorForm] = useState([]);
	const [validated, setValidated] = useState(false);
	const [defaultSelectedPage, setDefaultSelectedPage] = useState('News');
	const [defaultSelectedSection, setDefaultSelectedSection] = useState('News');

	const today = new Date();
	
	const [startDate, setStartDate] = useState(new Date());
	
	const [formData, setFormData] = useState({
		contentPage: 'News',
		section: 'News',
		title: '',
		descriptions: '',
		contents: '',
	});

	const editorDescRef = useRef();
	const editorContentRef = useRef();

	useEffect(() => {
		getDetails(id);
	}, []);


	const getDetails = (id) => {
		Api().get(`contents/${id}`)
		.then((response) => response)
		.then((detailsResponse) => {
			console.log(detailsResponse)
			if( detailsResponse.status === 200 )
			{	
				setDetails(detailsResponse.data)
				
				setFormData({...formData, ['descriptions']: detailsResponse.data.descriptions || ""})
				setFormData({...formData, ['contents']: detailsResponse.data.contents || ""})
			}
		})
		.catch((err) => {
		});
	}

	const onChangeEditorDesc = (e) => {
		setFormData({...formData, ['descriptions']: e})
	}

	const onChangeEditorContent = (e) => {
		setFormData({...formData, ['contents']: e})
	}

	const handleChange = (e) => {
		console.log(e)
		const key = e.target.name;
		const value = e.target.value;
		setFormData({...formData, [key]: value})
	}

	const handleChangeSelect = (e) => {
		const key = e.target.name;
		const value = e.target.value;
		setFormData({...formData, [key]: value})
	}
	
	const handleSubmit = (req) => {
		req.preventDefault();
		const form = req.currentTarget;
		if (form.checkValidity() === false) {
			req.preventDefault();
			req.stopPropagation();
			return;
		}

		setValidated(true);
		var data = new FormData(form);
		let formObject = Object.fromEntries(data.entries());
		formObject.descriptions = formData.descriptions;
		formObject.contents = formData.contents;
		
		Api().patch(`contents/${id}`, formObject)
		.then((response) => response)
		.then((data) => {
			if( data.status === 200 || data.status === 201){
				history.push('/news');
			}
		})
		.catch((err) => {
		});
	};
    
	return (
		<>
			<div style={{ display: 'flex', height: '100%', direction: 'ltr' }}>
				<DefaultLayout />
				{/* <div className={ getStyles().collapsed === true ? 'content-wrapper collapsed' : 'content-wrapper' }> */}
				<main>
					<div className="content-header">
						<Container fluid>
							<Row className="">
								<Col sm={4}>
									<h1 className="m-0">Edit News</h1>
								</Col>
								<Col sm={2}>
									{ checkMenu('news') &&
										<LinkRouter to="/news"><Button variant="outline-primary" className="btn-upload"><AiOutlineRollback /> Back</Button></LinkRouter>
									}
								</Col>
								<Col sm={3}>
								</Col>
								<Col sm={3}>
									<div className="date-time float-sm-right">
											{ moment().format('dddd, DD MMMM YYYY') }
									</div>
								</Col>
							</Row>
						</Container>
					</div>
							
					<div className="content">
						<Container fluid>
							<Row>
								<Col lg={12}>
									<Card className="content-list">
										<Card.Body>
											<Col md="12">
												<Form noValidate validated={validated} onSubmit={handleSubmit}>
													<input type="hidden" name="contentPage" value="News" />
													<input type="hidden" name="section" value="News" />
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Title</Form.Label>
															<Form.Control
																required
																type="textarea"
																name="title"
																defaultValue={details.title || formData.title}
																onChange={handleChange}
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom03">
															<Form.Label>Descriptions</Form.Label>
															<CKEditor
																editor={ ClassicEditor }
																config={ {
																	toolbar: [
																		'undo', 'redo', '|',
																		'heading', '|', 'bold', 'italic', '|',
																		'link', 'insertTable', 'mediaEmbed', '|',
																		'bulletedList', 'numberedList', 'indent', 'outdent'
																	],
        													licenseKey: 'GPL',
																	plugins: [
																		Bold,
																		Essentials,
																		Heading,
																		Indent,
																		IndentBlock,
																		Italic,
																		Link,
																		List,
																		MediaEmbed,
																		Paragraph,
																		Table,
																		Undo
																	],
																	root: {
																		initialData: details.descriptions || formData.descriptions,
																		placeholder: '',
																	},
																} }
																onReady={ (editor) => {
																	editorDescRef.current = editor;
																} }
																data={ details.descriptions || formData.descriptions }
																onChange={ () => {
																	onChangeEditorDesc( editorDescRef.current?.getData() );
																} }
															/>
														</Form.Group>	
                            <input type='hidden' defaultValue={formData.descriptions} name="descriptions" />
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom03">
															<Form.Label>Contents</Form.Label>
															<CKEditor
																editor={ ClassicEditor }
																config={ {
																	toolbar: [
																		'undo', 'redo', '|',
																		'heading', '|', 'bold', 'italic', '|',
																		'link', 'insertTable', 'mediaEmbed', '|',
																		'bulletedList', 'numberedList', 'indent', 'outdent'
																	],
        													licenseKey: 'GPL',
																	plugins: [
																		Bold,
																		Essentials,
																		Heading,
																		Indent,
																		IndentBlock,
																		Italic,
																		Link,
																		List,
																		MediaEmbed,
																		Paragraph,
																		Table,
																		Undo
																	],
																	root: {
																		initialData: details.contents || formData.contents,
																		placeholder: '',
																	},
																} }
																onReady={ (editor) => {
																	editorContentRef.current = editor;
																} }
																data={ details.contents || formData.contents }
																onChange={ () => {
																	onChangeEditorContent( editorContentRef.current?.getData() );
																} }
															/>
														</Form.Group>	
                            <input type='hidden' defaultValue={formData.contents} name="contents" />
													</Row>
													{error && 
														<Alert variant="danger">
															{error}
														</Alert>
													}
													<Button type="submit">Save</Button>
												</Form>
											</Col>
										</Card.Body>
									</Card>
								</Col>
							</Row>
						</Container>
					</div>
				</main>
			</div>
			<Footer />
		</>
	)
}
export default Editnews